module.exports = __webpack_public_path__ + "static/img/药店管理@2x2.9958f965.png";